import * as React from 'react';
import type { SVGProps } from 'react';

const IconData = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M60.713 15.094c-.438.219-.657.219-1.094.219-.875 0-1.531-.438-1.969-1.313l-2.187-4.375C41.243 41.344 14.775 43.75 7.119 43.75H4.93c-1.093-.219-1.968-1.313-1.968-2.406.218-1.313 1.312-2.188 2.406-1.969.219 0 30.406 2.844 45.937-31.281l-5.25 1.75c-.218 0-.437.219-.656.219-.875 0-1.75-.657-1.969-1.532-.437-1.094.22-2.406 1.313-2.844l9.844-3.28h.218c.22-.22.438-.22.438-.22h.875c.219 0 .219.22.437.22 0 0 .22 0 .22.218l.437.438 4.375 8.75c.656 1.53 0 2.843-.875 3.28Z"
      fill="#C5A26D"
    />
    <path fill="#F0ECE5" d="M2.961 66.313h66.06v1.5H2.961z" />
    <mask id="a" fill="#fff">
      <path d="M27.868 67.813v-25.03a1 1 0 0 1 1-1h14.246a1 1 0 0 1 1 1v25.03H27.868Z" />
    </mask>
    <path
      d="M27.868 67.813v-25.03a1 1 0 0 1 1-1h14.246a1 1 0 0 1 1 1v25.03H27.868Z"
      stroke="#F0ECE5"
      mask="url(#a)"
    />
    <mask id="b" fill="#fff">
      <path d="M51.736 67.813V29.5a1 1 0 0 1 1-1H68.02a1 1 0 0 1 1 1v38.311H51.736Z" />
    </mask>
    <path
      d="M51.736 67.813V29.5a1 1 0 0 1 1-1H68.02a1 1 0 0 1 1 1v38.311H51.736Z"
      stroke="#F0ECE5"
      mask="url(#b)"
    />
    <mask id="c" fill="#fff">
      <path d="M2.961 67.813V48.948a1 1 0 0 1 1-1h15.285a1 1 0 0 1 1 1v18.864H2.961Z" />
    </mask>
    <path
      d="M2.961 67.813V48.948a1 1 0 0 1 1-1h15.285a1 1 0 0 1 1 1v18.864H2.961Z"
      stroke="#F0ECE5"
      mask="url(#c)"
    />
  </svg>
);
export default IconData;
